import {applyMiddleware, combineReducers, createStore} from "redux";
import {thunk} from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension";
import modalReducer from "./modalReducer";
import productReducer from "./productReducer";
import productDetailReducer from "./productDetailReducer";
import countPageReducer from "./countPageReducer";
import modalDataReducer from "./modalDataReducer";
import similarProductReducer from "./similarProductReducer";
import modalFormReducer from "./ModalFormReducer";
import galleryReducer from "./galleryReducer";

const rootReducers = combineReducers({
    modal: modalReducer,
    product: productReducer,
    productDetail: productDetailReducer,
    countPage: countPageReducer,
    modalData: modalDataReducer,
    similarProduct: similarProductReducer,
    modalForm: modalFormReducer,
    gallery: galleryReducer
})

export const store = createStore(rootReducers, composeWithDevTools(applyMiddleware(thunk)))